export default __webpack_public_path__ + "static/media/7.80d420f8.svg";